<mat-nav-list class="navigation-menu-panel" *ngIf="!(breakpointObserverService.isMobile | async)">
  <!-- The full horizontal lockup, not the standalone mark: this rail is the
       app's only logo whenever it is on screen, because app-top-nav hides its
       own copy at exactly these widths (see that component's
       sidenav-rail-visible mixin). Plain <img>, matching app-top-nav, rather
       than app-icon/MatIconRegistry - the SVG carries id-referenced gradients
       that collide when the same markup is inlined more than once. A data URI
       keeps that property, since every <img> is its own document, and costs
       one round trip less on first paint. -->
  <button
    #moreMenuToggle
    type="button"
    class="logo-lockup more-menu-toggle"
    (click)="toggleMoreMenu()"
    [attr.aria-expanded]="isMoreMenuOpen"
    aria-haspopup="true"
    aria-controls="more-menu"
    aria-label="More options"
  >
    <img [src]="logoSrc" alt="Map AI" width="141" height="68"/>
  </button>

  <div class="desktop-pointer">
<!--    <app-icon svgIcon="pointer"></app-icon>-->
  </div>

  <div class="navmenu-links">
<!--    <a href="http://map-ai.co" target="_blank" matTooltip="Home" matTooltipPosition="right">-->
<!--      <app-icon svgIcon="home"></app-icon>-->
<!--    </a>-->

    <a #navLink
       routerLink="/"
       [class.active-link]="isActiveWithQueryParams('/')"
       matTooltip="Explore the interactive map"
       matTooltipPosition="right"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="home"
      ></app-icon>
      <span>Home</span>
    </a>

    <a #navLink
       [routerLink]="'chat'"
       matTooltip="Ask AI about any location"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="ai_chat"
      ></app-icon>
      <span>AI Chat</span>

    </a>

    <a #navLink
       [routerLink]="'reports'"
       matTooltip="Download a full location analysis as PDF"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="report"
      ></app-icon>
      <span>Order report</span>

    </a>

    <a #navLink
       [routerLink]="salesForecastLink"
       matTooltip="Choose a perfect location for your business"
       matTooltipPosition="right"
       [class.active-link]="isSalesForecastActive"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="site-selection"
      ></app-icon>
      <span>Sales Forecast</span>
    </a>

  </div>

  <div class="user-icon-container">
    <a *ngIf="accessService.getIsAdmin()"
       #navLink
       [routerLink]="'admin'"
       matTooltip="Manage users and platform settings" matTooltipPosition="right"
    >
      <app-icon
        routerLinkActive="active-link"
        svgIcon="adminPanel"
        class="admin-icon"
      ></app-icon>
    </a>
    <a #navLink class="user-icon-circle" routerLinkActive="active-link" [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'" [matTooltip]="authService.hasAccessToken() ? 'Manage your subscription and account' : 'Log in to access premium features'" matTooltipPosition="right">
      <app-icon
        [svgIcon]="authService.hasAccessToken() ? 'user' : 'logIn'"
        class="user-icon"></app-icon>
    </a>
  </div>
</mat-nav-list>

<nav
  id="more-menu"
  class="more-menu-panel more-menu-panel-desktop"
  *ngIf="!(breakpointObserverService.isMobile | async)"
  [class.open]="isMoreMenuOpen"
  aria-label="More"
>
  <ng-container *ngTemplateOutlet="moreMenuLinks"></ng-container>
</nav>

<nav class="navigation-menu-panel-mobile" *ngIf="breakpointObserverService.isMobile | async" >
  <!-- Single sliding pointer for mobile -->
  <div class="mobile-pointer">
  </div>

  <div class="navmenu-links">
<!--    <a href="http://map-ai.co" target="_blank">-->
<!--      <app-icon svgIcon="home"></app-icon>-->
<!--    </a>-->

    <a #navLink routerLink="/">
      <app-icon
        svgIcon="home"
        [class.active-link]="isActiveWithQueryParams('/')"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'chat'" class="user-icon">
      <app-icon
        [svgIcon]="'ai_chat'"
        [class.active-link]="isActiveWithQueryParams('/chat')"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'" class="user-icon">
      <app-icon
        [svgIcon]="authService.hasAccessToken() ? 'user' : 'logIn'"
        [class.active-link]="isActiveWithQueryParams('/user')"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a *ngIf="accessService.getIsAdmin()"
       #navLink
       [routerLink]="'/admin'">
      <app-icon
        svgIcon="adminPanel"
        routerLinkActive="active-link"
        class="admin-icon"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="salesForecastLink">
      <app-icon
        svgIcon="site-selection"
        [class.active-link]="isSalesForecastActive"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'/reports'">
      <app-icon
        svgIcon="report"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

  </div>

  <button
    #moreMenuToggle
    type="button"
    class="more-menu-toggle more-menu-toggle-corner"
    (click)="toggleMoreMenu()"
    [attr.aria-expanded]="isMoreMenuOpen"
    aria-haspopup="true"
    aria-controls="more-menu"
    aria-label="More options"
  >
    <img
      src="/assets/icons/navigation-menu/logo.svg"
      alt=""
      width="24"
      height="21"
    />
  </button>

  <nav
    id="more-menu"
    class="more-menu-panel"
    [class.open]="isMoreMenuOpen"
    aria-label="More"
  >
    <ng-container *ngTemplateOutlet="moreMenuLinks"></ng-container>
  </nav>
</nav>

<ng-template #moreMenuLinks>
  <a href="/explore/us/overview" (click)="closeMoreMenu()"
    >Explore US Data</a
  >
  <a routerLink="/comparative-location-tool" (click)="closeMoreMenu()"
    >Compare Locations</a
  >
  <a [href]="blogUrl" (click)="closeMoreMenu()">Blog</a>
  <a routerLink="/info/data-sources" (click)="closeMoreMenu()"
    >Data Sources</a
  >
  <a routerLink="/pricing" (click)="closeMoreMenu()">Pricing</a>
</ng-template>
